<script>
    export let row = {};    
</script>

{#if row.element_validity == 'INVALID'}
    <i class="fa fa-exclamation-circle text-danger" style="margin-right: 3px;"></i>{row.name}
{:else}
    {row.name}
{/if}
